module.exports = __webpack_public_path__ + "img/home-bg3.e9f41a41.png";